import React, { Fragment } from 'react'
import RenditionGuide from '../../mdx/optional-settings/rendition-guide.mdx'
import ContentRating from '../../mdx/optional-settings/content-rating.mdx'
import LanguageSupport from '../../mdx/optional-settings/language-support.mdx'
import DocsPageGlobalStyles from '../../styles/docs-page'
import Anchor from '../anchor'
import DividerLine from '../shared/divider-line'

const DocsSection = ({ children, anchorId, dividerLine = true }) => {
    return (
        <section>
            {dividerLine ? <DividerLine /> : ''}
            <Anchor id={anchorId} />
            {children}
        </section>
    )
}

const OptionalSettings = () => {
    return (
        <Fragment>
            <DocsPageGlobalStyles />
            <div className="docsContainer">
                <DocsSection dividerLine={false} anchorId="rendition-guide">
                    <RenditionGuide />
                </DocsSection>
                <DocsSection anchorId="language-support">
                    <LanguageSupport />
                </DocsSection>
                <DocsSection anchorId="rating">
                    <ContentRating />
                </DocsSection>
            </div>
        </Fragment>
    )
}

export default OptionalSettings
